import authRequest from '../shared/authRequest';
import multiRequest from '../shared/multiRequest';

const getSplashScreenAds = () =>
  authRequest([
    {
      url: 'contentful/splash-screen',
      method: 'GET',
    },
  ]);

const getGlobalData = () =>
  multiRequest([
    {
      url: 'contentful/global-data',
      method: 'GET',
    },
  ]);

const getFAQModelData = section =>
  multiRequest([
    {
      url: `contentful/faq-data?section=${section}`,
      method: 'GET',
    },
  ]);

const getLoyaltyData = () =>
  multiRequest([
    {
      url: `contentful/loyalty`,
      method: 'GET',
    },
  ]);

const getInvoicesMessage = () =>
  multiRequest([
    {
      url: `contentful/invoices-message`,
      method: 'GET',
    },
  ]);

const getDeviceMessage = () =>
  multiRequest([
    {
      url: `contentful/info-device-message`,
      method: 'GET',
    },
  ]);

const getNavbarItems = () =>
  multiRequest([
    {
      url: `contentful/navbar`,
      method: 'GET',
    },
  ]);

const getSocialNetworkIcons = () =>
  multiRequest([
    {
      url: `contentful/social-networks-icons`,
      method: 'GET',
    },
  ]);

const getFrequentCountries = () =>
  multiRequest([
    {
      url: `contentful/roaming-frequent-countries`,
    },
  ]);

const getTermsAndConditions = () =>
  multiRequest([
    {
      url: `contentful/terms-and-conditions`,
      method: 'GET',
    },
  ]);

const getArmorCampaign = data =>
  multiRequest([
    {
      url: `contentful/armor-campaign`,
      method: 'POST',
      data,
    },
  ]);

const closeArmorCampaign = data =>
  multiRequest([
    {
      url: `contentful/close-armor-campaign`,
      method: 'POST',
      data,
    },
  ]);

const getNewsButtons = () =>
  multiRequest([
    {
      url: `contentful/news-buttons`,
      method: 'GET',
    },
  ]);

const getMenu = (isWompayEnabled, hasKushkiCards) =>
  multiRequest([
    {
      url: `contentful/menu?isWompay=${isWompayEnabled}&isKushki=${hasKushkiCards}`,
      method: 'GET',
    },
  ]);

const getCatalogDevices = () =>
  multiRequest([
    {
      url: `contentful/catalog-device`,
      method: 'GET',
    },
  ]);

const getSmartBanner = () =>
  multiRequest([
    {
      url: `contentful/smart-banner`,
      method: 'GET',
    },
  ]);

const getInterestingFeatures = () =>
  multiRequest([
    {
      url: `contentful/getInterestingFeatures`,
      method: 'GET',
    },
  ]);

export {
  getSplashScreenAds,
  getGlobalData,
  getFAQModelData,
  getLoyaltyData,
  getInvoicesMessage,
  getDeviceMessage,
  getNavbarItems,
  getSocialNetworkIcons,
  getFrequentCountries,
  getTermsAndConditions,
  getArmorCampaign,
  closeArmorCampaign,
  getNewsButtons,
  getMenu,
  getCatalogDevices,
  getSmartBanner,
  getInterestingFeatures,
};

export default {
  getSplashScreenAds,
  getGlobalData,
  getFAQModelData,
  getLoyaltyData,
  getInvoicesMessage,
  getDeviceMessage,
  getNavbarItems,
  getSocialNetworkIcons,
  getFrequentCountries,
  getTermsAndConditions,
  getArmorCampaign,
  closeArmorCampaign,
  getNewsButtons,
  getMenu,
  getCatalogDevices,
  getSmartBanner,
  getInterestingFeatures,
};
